<template>
  <div class="container">
    <div class="section">
      <div>Richtig: {{wks.succeeded}}</div>
      <div>Falsch: {{wks.failed}}</div>
    </div>
  </div>
</template>

<script>
  import learnApiClient from '../LearnApiClient';

  export default {
    name: "completed",
    data() {
      return {
        wks: null
      }
    },
    async mounted() {
      var id = this.$router.currentRoute.params.id;
      console.log(id);

      var data = await learnApiClient.getWorksheetSummary(id);

      this.wks = data;
      console.log(data);
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/worksheets/completed.vue